import { render, staticRenderFns } from "./jessibucaVideo.vue?vue&type=template&id=40a86d1e&scoped=true"
import script from "./jessibucaVideo.vue?vue&type=script&lang=js"
export * from "./jessibucaVideo.vue?vue&type=script&lang=js"
import style0 from "./jessibucaVideo.vue?vue&type=style&index=0&id=40a86d1e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a86d1e",
  null
  
)

export default component.exports